"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

exports.__esModule = true;

var styled_components_1 = require("styled-components");

exports.TEXT_BLOCK_MAX_WIDTH = 700;
var headerCommon = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 0.5em;\n  font-weight: normal;\n  color: ", ";\n"], ["\n  margin-bottom: 0.5em;\n  font-weight: normal;\n  color: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});
exports.h2 = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n  line-height: 1.25;\n  font-size: 1.8rem;\n"], ["\n  ", "\n  line-height: 1.25;\n  font-size: 1.8rem;\n"])), headerCommon);
exports.formattedTextCss = styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  > h2,\n  > h3 {\n    ", "\n  }\n  > h2 {\n    ", "\n  }\n  > h3 {\n    line-height: 1.25;\n    font-size: 1.5rem;\n  }\n  > p {\n    position: relative;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  > hr {\n    height: 1px;\n    border: 0;\n    background: #222;\n  }\n  > ul,\n  > ol {\n    margin: 0;\n    padding: 0 ", "px;\n  }\n"], ["\n  > h2,\n  > h3 {\n    ", "\n  }\n  > h2 {\n    ", "\n  }\n  > h3 {\n    line-height: 1.25;\n    font-size: 1.5rem;\n  }\n  > p {\n    position: relative;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  > hr {\n    height: 1px;\n    border: 0;\n    background: #222;\n  }\n  > ul,\n  > ol {\n    margin: 0;\n    padding: 0 ", "px;\n  }\n"])), headerCommon, exports.h2, function (_a) {
  var theme = _a.theme;
  return theme.app.padding || 0;
});
exports.general = styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  box-sizing: border-box;\n  max-width: ", "px;\n  margin: 0 auto;\n  color: ", ";\n  line-height: 1.4;\n  position: relative;\n  padding: 0;\n  .ql-align-justify {\n    text-align: inherit;\n  }\n  .ql-align-center {\n    text-align: center;\n  }\n  .ql-align-right {\n    text-align: right;\n  }\n"], ["\n  box-sizing: border-box;\n  max-width: ", "px;\n  margin: 0 auto;\n  color: ", ";\n  line-height: 1.4;\n  position: relative;\n  padding: 0;\n  .ql-align-justify {\n    text-align: inherit;\n  }\n  .ql-align-center {\n    text-align: center;\n  }\n  .ql-align-right {\n    text-align: right;\n  }\n"])), function (_a) {
  var theme = _a.theme;
  return theme.app.maxWidth;
}, function (_a) {
  var theme = _a.theme;
  return theme.app.textColor;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;